import history from '../store/history'

export const addActualPathRedirectSlugToPath = (path) => {
  const [actualPath] = history.location.pathname.split('?')

  if (path.includes(actualPath)) {
    return path
  }

  if (path.includes('?')) {
    return `${path}&redirect=${actualPath}`
  }
  return `${path}?redirect=${actualPath}`
}
